import { ClasseEquipamentoService } from "src/app/services/classe-equipamento.service";
import { ClasseEquipamento, Prioridade } from "./../../domain/domain.model";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { GrupoLocalNivelService } from "src/app/services/grupo-local-nivel.service";
import { Component, OnInit, AfterContentInit } from "@angular/core";
import { FabricantedeService } from "src/app/pages/cadastros/services/fabricante.service";
import { AtividadeService } from "src/app/pages/cadastros/atividade/atividade.service";
import { ToastrService } from "ngx-toastr";
import { UsuarioService } from "src/app/services/usuario.service";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { TipoEquipamentoService } from "src/app/services/tipo-equipamento.service";
import { GrupoLocalNivel1, TipoDeEquipamento } from "../../domain/domain.model";
import { CommandResult } from "../../domain/commandResult";
import { APP_SETTINGS, SCAMP_API } from "src/environments/environment";
import { SCAMP_API_RPT } from "src/environments/environment";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { dayWeeks, dayWeeksOrd } from "src/app/utils/dayWeeks";
import * as moment from "moment";
import { OSService } from "src/app/services/os-service";

@Component({
  selector: "app-atividade",
  templateUrl: "./atividade.component.html",
  styleUrls: ["./atividade.component.scss"],
  providers: [FabricantedeService, AtividadeService],
})
export class AtividadeComponent implements OnInit, AfterContentInit {
  constructor(
    private fabricanteService: FabricantedeService,
    private atividadeService: AtividadeService,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private tipoEquipamentoService: TipoEquipamentoService,
    private grupoLocalService: GrupoLocalNivelService,
    private modalService: NgbModal,
    private equipamentoService: EquipamentoService,
    private classeEquipamentoService: ClasseEquipamentoService,
    private osservice: OSService
  ) {}

  public fabricantes: any[] = [];
  public resultadosPesquisa: any[] = [];
  public atividades: any[] = [];
  public atividadesFilters: any[] = [];
  public tiposEquipamentos: TipoDeEquipamento[] = [];
  public classesEquipamentos: ClasseEquipamento[] = [];

  public isEditing = false;
  public isProcessing = false;
  public isReprintOS = false;
  public isFiltered = false;
  public isLoading = false;
  public nenhumResultado = false;

  public equipamentoSelecionado = "";
  public equipamentoSelecionadoId = 0;

  public voids: string[] = [];
  public maxRowsVoids = 4;
  public autorizacoes: UsuarioAutorizacoes;
  public parametros: any;
  public validaDataInicio: string = "";
  public validaDataTermino: string = "";
  public validaNovaDataProximaExecucao: string = "";
  public validaDataInicioNovoPlano: string = "";
  public validaDataTerminoNovoPlano: string = "";
  public validaNovaDataPlanoProximaExecucao: string = "";

  public gruposLocais: GrupoLocalNivel1[] = [];
  public filtroAplicado: string = "";
  public anoProximaExecucao: string = "";

  public excelFileName: string = "";
  public hrefExcelFile: string = "";
  public isGeneratingToExcel: boolean = false;
  public atividadeSelecionada: any;
  public proximaExecucaoSelecionada: string | null;
  public dayWeek: string;
  public osIdSelecionada: number;
  public hasSomeOsIdSelecionada: boolean;
  public dayWeeks = dayWeeks;
  public dayWeeksOrd = dayWeeksOrd;

  public orderByRotina: boolean = true;

  public defaultPeriodicidades = [-1, 30, 60, 90, 180, 365];
  public mesesPeriodicidade = [-1, 1, 2, 3, 6, 12];

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("atividade");
  }

  ngOnInit() {
    this.getFabricantes();
    this.getGruposLocais();
    this.setVoids();
    this.getTiposEquipamentos();
    this.getClassesEquipamentos();
  }

  getGruposLocais() {
    this.grupoLocalService
      .getAllGrupoLocalNivel1()
      .subscribe((response: GrupoLocalNivel1[]) => {
        this.gruposLocais = response;
      });
  }
  private getTiposEquipamentos() {
    this.tipoEquipamentoService
      .getAll()
      .subscribe((response: TipoDeEquipamento[]) => {
        this.tiposEquipamentos = response;
      });
  }

  getFabricantes() {
    this.fabricanteService
      .list()
      .subscribe((response) => (this.fabricantes = response));
  }

  getClassesEquipamentos() {
    this.classeEquipamentoService
      .getAll()
      .subscribe((response: ClasseEquipamento[]) => {
        this.classesEquipamentos = response;
      });
  }

  keyUpPlano(value) {
    this.anoProximaExecucao = value;
    this.excelFileName = "";
    this.hrefExcelFile = "";
  }

  public getDetailsEquipamento(equipamentoId: number, nome: string) {
    this.filtroAplicado = "";
    this.getById(equipamentoId, nome);
  }

  private getById(equipamentoId: number, nome: string): void {
    this.isProcessing = true;
    this.reset();
    this.equipamentoSelecionado = nome;
    this.equipamentoSelecionadoId = equipamentoId;

    this.atividadeService.list(equipamentoId).subscribe(
      (response) => {
        this.atividades = response.sort((a, b) => {
          if (
            `${a.areaTecnica}${a.rotinaPadrao}` <
            `${b.areaTecnica}${b.rotinaPadrao}`
          )
            return -1;
          if (
            `${a.areaTecnica}${a.rotinaPadrao}` >
            `${b.areaTecnica}${b.rotinaPadrao}`
          )
            return 1;
          return 0;
        });

        if (this.orderByRotina == false) {
          this.atividadesFilters = this.atividades.sort((a, b) => {
            let lengthA = a.proximasExecucoes ? a.proximasExecucoes.length : 0;
            let lengthB = b.proximasExecucoes ? b.proximasExecucoes.length : 0;
            return lengthB - lengthA;
          });
        } else {
          this.atividadesFilters = [].concat(this.atividades);
        }

        this.isEditing = true;
        this.isProcessing = false;
        this.setVoids();

        if (this.filtroAplicado != "") {
          this.filtrarAtividades(this.filtroAplicado);
        }
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public OrderByAtividades(value: boolean) {
    this.orderByRotina = value;

    if (this.orderByRotina) {
      this.atividadesFilters = this.atividadesFilters.sort((a, b) => {
        if (
          `${a.areaTecnica}${a.rotinaPadrao}` <
          `${b.areaTecnica}${b.rotinaPadrao}`
        )
          return -1;
        if (
          `${a.areaTecnica}${a.rotinaPadrao}` >
          `${b.areaTecnica}${b.rotinaPadrao}`
        )
          return 1;
        return 0;
      });
    } else {
      this.atividadesFilters = this.atividadesFilters.sort((a, b) => {
        let lengthA = a.proximasExecucoes ? a.proximasExecucoes.length : 0;
        let lengthB = b.proximasExecucoes ? b.proximasExecucoes.length : 0;

        return lengthB - lengthA;
      });
    }
  }

  public filtrarAtividades(filtro: string) {
    this.filtroAplicado = "";

    if (this.atividades.length == 0) {
      return;
    }

    this.filtroAplicado = filtro;

    this.atividadesFilters = this.atividades.filter((t) =>
      String(`${t.rotinaCodigo} - ${t.rotinaPadrao}`)
        .toLocaleLowerCase()
        .includes(filtro.toLocaleLowerCase())
    );

    this.OrderByAtividades(this.orderByRotina);
  }

  public clearFiltro() {
    this.atividadesFilters = this.atividades;
    this.OrderByAtividades(this.orderByRotina);
    (document.getElementById("inputFiltro") as HTMLInputElement).value = "";
    this.filtroAplicado = "";
  }

  public resetParametrosPesquisa(): void {
    (document.getElementById("inputFiltro") as HTMLInputElement).value = "";
    (document.getElementById("inputDataInicio") as HTMLInputElement).value = "";
    (document.getElementById("inputDataTermino") as HTMLInputElement).value =
      "";

    this.validaDataInicio = "";
    this.validaDataTermino = "";
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isReprintOS = false;
    this.isLoading = false;
    this.atividades = [];
    this.atividadesFilters = [];
    this.setVoids();

    this.excelFileName = "";
    this.hrefExcelFile = "";
    this.isGeneratingToExcel = false;
    this.equipamentoSelecionado = "";
  }

  buscar(parametros: any) {
    this.parametros = parametros;
    this.resultadosPesquisa = [];
    this.reset();
    this.setVoids();
    this.destacar(); // destaca campo selecionados como parâmetros

    this.isProcessing = true;
    this.nenhumResultado = false;

    this.atividadeService.search(parametros).subscribe(
      (response) => {
        this.resultadosPesquisa = response;

        if (this.resultadosPesquisa.length === 0) {
          this.nenhumResultado = true;
        }
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public setVoids(): void {
    this.voids = [];
    if (this.atividades.length < this.maxRowsVoids) {
      for (let i = this.atividades.length; i < this.maxRowsVoids; i++) {
        this.voids.push("");
      }
    }
  }

  public showError(error: any) {
    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error("Ocorreu um erro no servidor");
    }

    this.isProcessing = false;
  }

  destacar() {
    const selects = document.getElementsByTagName("select");
    const inputs = document.getElementsByTagName("input");

    Array.from(selects).forEach((s) => s.classList.remove("has-param"));
    Array.from(inputs).forEach((i) => i.classList.remove("has-param"));

    Array.from(selects).forEach((s) => {
      if (s.value !== "") {
        s.classList.add("has-param");
      }
    });
    Array.from(inputs).forEach((i) => {
      if (i.value !== "" && i.classList.contains("parametro")) {
        i.classList.add("has-param");
      }
    });
  }

  public UpdateProximaExecucao(
    proximaExecucao: string,
    periodicidadeId: number
  ) {
    if (proximaExecucao !== "") {
      const atividade = this.atividades.find(
        (a) => a.periodicidadeId === periodicidadeId
      );
      atividade.proximaExecucao = proximaExecucao;
      atividade.equipamentoId = this.equipamentoSelecionadoId;
    }
  }

  validaDatasInicioFinal() {
    this.validaDataInicio = "";
    this.validaDataTermino = "";

    this.excelFileName = "";
    this.hrefExcelFile = "";

    const inputDataInicio = (
      document.getElementById("inputDataInicio") as HTMLInputElement
    ).value;
    const inputDataTermino = (
      document.getElementById("inputDataTermino") as HTMLInputElement
    ).value;

    let validInputDataInicio = true;
    let validInputDataTermino = true;

    if (inputDataInicio == "" || Number(inputDataInicio.split("-")[0]) < 2000) {
      this.validaDataInicio = "Informe uma data válida";
      validInputDataInicio = false;
    }

    if (
      inputDataTermino == "" ||
      Number(inputDataTermino.split("-")[0]) < 2000
    ) {
      this.validaDataTermino = "Informe uma data válida";
      validInputDataTermino = false;
    }

    return validInputDataInicio && validInputDataTermino;
  }

  nenhumDataProximaExecucao() {
    const dados = this.atividadesFilters.filter((a) => a.proximaExecucao);

    return dados.length === 0;
  }

  public submit() {
    if (this.validaDatasInicioFinal()) {
      const inputDataInicio = (
        document.getElementById("inputDataInicio") as HTMLInputElement
      ).value;
      const inputDataTermino = (
        document.getElementById("inputDataTermino") as HTMLInputElement
      ).value;

      const dados = this.atividadesFilters.filter((a) => a.proximaExecucao);

      let dataInicio = new Date(
        new Date(inputDataInicio).getTime() + 3 * 60 * 60 * 1000
      );
      let dataTermino = new Date(
        new Date(inputDataTermino).getTime() + 3 * 60 * 60 * 1000
      );

      this.gerarPlano(dados, dataInicio, dataTermino, null);
    }
  }

  private gerarPlano(dados, inputDataInicio, inputDataTermino, c: any) {
    if (dados.length > 0) {
      const atividades: any[] = [];
      let dataIntervaloInicio = new Date(inputDataInicio).getTime();
      let dataIntervaloTermino = new Date(inputDataTermino).getTime();

      if (dataIntervaloInicio > dataIntervaloTermino) {
        const dataTemp = dataIntervaloInicio;
        dataIntervaloInicio = dataIntervaloTermino;
        dataIntervaloTermino = dataTemp;
      }

      let count: number = 0;

      dados.forEach((d) => {
        const proximaExecucao = new Date(d.proximaExecucao).getTime();
        let dataProximaExecucao =
          new Date(proximaExecucao).getTime() + 3 * 60 * 60 * 1000;

        count == 0;
        // guarda o dia originalmente fornecido pelo usuário
        let originalDataProximaExecucao = new Date(
          new Date(d.proximaExecucao).getTime() + 3 * 60 * 60 * 1000
        );

        if (dataIntervaloInicio > dataProximaExecucao) {
          while (dataProximaExecucao < dataIntervaloInicio) {
            count++;
            dataProximaExecucao = this.getProximaDataExecucao(
              originalDataProximaExecucao,
              1,
              count
            ).getTime();
          }

          originalDataProximaExecucao = new Date(dataProximaExecucao);
        }

        count = 0;

        while (
          dataProximaExecucao >= dataIntervaloInicio &&
          dataProximaExecucao <= dataIntervaloTermino
        ) {
          // proxExecFinalSemana==true, salta data quando cai SAB ou DOM
          if (APP_SETTINGS.proxExecFinalSemana && count >= 0) {
            if (new Date(dataProximaExecucao).getDay() === 0) {
              dataProximaExecucao =
                new Date(dataProximaExecucao).getTime() + 24 * 60 * 60 * 1000; // Dia de semana, caiu no domingo. Altera para segunda
            } else if (new Date(dataProximaExecucao).getDay() === 6) {
              dataProximaExecucao =
                new Date(dataProximaExecucao).getTime() +
                2 * 24 * 60 * 60 * 1000; //Dia de semana, caiu no sábado. Altera para segunda
            }
          }

          const atividade = atividades.find(
            (x) =>
              x.proximaExecucao ===
                new Date(dataProximaExecucao).toISOString().split("T")[0] &&
              x.equipamentoId === d.equipamentoId &&
              x.periodicidadeId === d.periodicidadeId
          );

          if (atividade == undefined) {
            const isAdd = atividades.some(
              (a) =>
                a.proximaExecucao ===
                new Date(dataProximaExecucao).toISOString().split("T")[0]
            );

            if (isAdd === false) {
              atividades.push({
                id: d.id,
                proximaExecucao: new Date(dataProximaExecucao)
                  .toISOString()
                  .split("T")[0],
                equipamentoId: d.equipamentoId,
                periodicidadeId: d.periodicidadeId,
                espacamento: d.espacamento,
              });
            }
          }

          dataProximaExecucao = this.getProximaDataExecucao(
            originalDataProximaExecucao,
            d.espacamento,
            count
          ).getTime();

          count++;
        }
      }); // fim foreach

      this.isProcessing = true;

      this.atividadeService.create(atividades).subscribe(
        (response: CommandResult) => {
          if (response.success === true) {
            this.toastr.success(
              "Atividade(s) cadastrada(s)/editada(s) com sucesso"
            );
            const equipSelecionado = this.resultadosPesquisa.find(
              (x) => x.id == this.equipamentoSelecionadoId
            );
            equipSelecionado.qtdAtividades = atividades.length;

            //this.modalService.dismissAll();

            this.getById(
              this.equipamentoSelecionadoId,
              this.equipamentoSelecionado
            );
            this.atividadeSelecionada = undefined;

            if (c) {
              c("Close click");
            }
          } else {
            this.toastr.error(response.message);
          }
        },
        (exception: any) => {
          this.showErrorExecption(exception);
          this.isProcessing = false;
        },
        () => (this.isProcessing = false)
      );
    } else {
      this.toastr.warning("Nenhuma data de próxima execução foi definida");
    }
  }

  public limparParametros() {
    const selects = document.getElementsByTagName("select");
    const inputs = document.getElementsByTagName("input");

    Array.from(selects).forEach((s) => (s.value = ""));
    Array.from(inputs).forEach((i) => (i.value = ""));

    this.destacar();
    this.resultadosPesquisa = [];
    this.reset();
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`
    );
  }

  public showModalGerarPlanoManutencao(modal: any) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
    (document.getElementById("inputFiltro") as HTMLInputElement).value =
      this.filtroAplicado;
    this.getById(this.equipamentoSelecionadoId, this.equipamentoSelecionado);
  }

  getPlanoManutencaoExcel() {
    if (this.resultadosPesquisa.length > 0) {
      this.isGeneratingToExcel = true;

      const equipamentosIds = this.resultadosPesquisa
        .map((x) => x.id)
        .toString();

      this.equipamentoService
        .getPlanoManutencaoExcel(equipamentosIds, this.anoProximaExecucao)
        .subscribe((response) => {
          if (response.success === true) {
            if (response.nenhumResultado === false) {
              this.excelFileName = response.fileName;
              this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
            } else {
              this.toastr.warning(response.msgErro);
            }

            this.isGeneratingToExcel = false;
          } else {
            this.toastr.error(response.msgException);
            this.isGeneratingToExcel = false;
          }
        });
    }
  }

  removeLinkExcel() {
    this.excelFileName = "";
    this.hrefExcelFile = "";
  }

  editDataProximaExecucao(atividade, proxExec, modal) {
    this.atividadeSelecionada = atividade;
    this.proximaExecucaoSelecionada = proxExec.proximaExecucao;
    this.dayWeek = this.dayWeeks[proxExec.ds];
    this.osIdSelecionada = proxExec.osId;

    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  editPlanoExecucao(atividade, modal) {
    this.atividadeSelecionada = atividade;
    this.hasSomeOsIdSelecionada =
      this.atividadeSelecionada.proximasExecucoes.some((x) => x.osId != null);
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  public updateDataProximaExecucao(c: any) {
    this.validaNovaDataProximaExecucao = "";

    const inputDataProximaExecucao = (
      document.getElementById(
        "inputNovaDataProximaExecucao"
      ) as HTMLInputElement
    ).value;

    if (inputDataProximaExecucao == "") {
      this.validaNovaDataProximaExecucao = "Informe uma data válida";
      return;
    }

    let inputData = new Date(
      new Date(inputDataProximaExecucao).getTime() + 3 * 60 * 60 * 1000
    ); // correção GMT

    

    const findData = this.atividadeSelecionada.proximasExecucoes
      .filter((x) => x != this.proximaExecucaoSelecionada)
      .find((x) => x == this.proximaExecucaoSelecionada);

    if (findData != undefined) {
      this.validaNovaDataProximaExecucao = "Esta data já foi inserida";
      return;
    }

    this.atividadeService
      .updateDataProximaExecucao(
        this.atividadeSelecionada.equipamentoId,
        this.atividadeSelecionada.periodicidadeId,
        this.proximaExecucaoSelecionada,
        inputData.toISOString().split("T")[0]
      )
      .subscribe((response: boolean) => {
        if (response) {
          this.getById(
            this.equipamentoSelecionadoId,
            this.equipamentoSelecionado
          );
          this.atividadeSelecionada = undefined;
          this.proximaExecucaoSelecionada = "";
          this.dayWeek = "";
          this.osIdSelecionada = null;
          c("Close click");
        } else {
          this.validaNovaDataProximaExecucao =
            "Ocorreu um erro ao tentar salvar a data";
        }
      });
  }

  public updatePlanoProximasExecucoes(c: any) {
    this.validaDataInicioNovoPlano = "";
    this.validaDataTerminoNovoPlano = "";
    this.validaNovaDataPlanoProximaExecucao = "";

    const inputDataInicioNovoPlano = (
      document.getElementById("inputDataInicioNovoPlano") as HTMLInputElement
    ).value;
    const inputDataTerminoNovoPlano = (
      document.getElementById("inputDataTerminoNovoPlano") as HTMLInputElement
    ).value;
    const inputNovaDataPlano = (
      document.getElementById(
        "inputNovaDataPlanoProximaExecucao"
      ) as HTMLInputElement
    ).value;

    let validDataInicioNovoPlano = true;
    let validinputDataTerminoNovoPlano = true;
    let validinputNovaDataPlano = true;

    if (
      inputDataInicioNovoPlano == "" ||
      Number(inputDataInicioNovoPlano.split("-")[0]) < 2000
    ) {
      this.validaDataInicioNovoPlano = "Informe uma data válida";
      validDataInicioNovoPlano = false;
    }

    if (
      inputDataTerminoNovoPlano == "" ||
      Number(inputDataTerminoNovoPlano.split("-")[0]) < 2000
    ) {
      this.validaDataTerminoNovoPlano = "Informe uma data válida";
      validinputDataTerminoNovoPlano = false;
    }

    if (
      inputNovaDataPlano == "" ||
      Number(inputNovaDataPlano.split("-")[0]) < 2000
    ) {
      this.validaNovaDataPlanoProximaExecucao = "Informe uma data válida";
      validinputNovaDataPlano = false;
    }

    if (
      !validDataInicioNovoPlano ||
      !validinputDataTerminoNovoPlano ||
      !validinputNovaDataPlano
    ) {
      return;
    }

    let inputDataInicio = new Date(
      new Date(inputDataInicioNovoPlano).getTime() + 3 * 60 * 60 * 1000
    );
    let inputDataTermino = new Date(
      new Date(inputDataTerminoNovoPlano).getTime() + 3 * 60 * 60 * 1000
    );
    let inputNovaData = new Date(
      new Date(inputNovaDataPlano).getTime() + 3 * 60 * 60 * 1000
    );

    this.geraNovoPlanoExecucao(
      inputDataInicio,
      inputDataTermino,
      inputNovaData,
      c
    );
  }

  geraNovoPlanoExecucao(
    inputDataInicio,
    inputDataTermino,
    inputNovaData,
    c: any
  ) {
    this.atividadeSelecionada.proximaExecucao = inputNovaData
      .toISOString()
      .split("T")[0];

    this.atividadeService
      .removePlanoExecucao(
        this.atividadeSelecionada.equipamentoId,
        this.atividadeSelecionada.periodicidadeId
      )
      .subscribe((response: boolean) => {
        if (response) {
          this.gerarPlano(
            [].concat(this.atividadeSelecionada),
            inputDataInicio,
            inputDataTermino,
            c
          );
        } else {
          this.validaDataTerminoNovoPlano = "Erro ao tentar editar o período";
        }
      });
  }

  removerPlanoManutencao(atividade, modal) {
    this.atividadeSelecionada = atividade;
    this.modalService.open(modal, { windowClass: "sm", backdrop: "static" });
  }

  public delete(c: any): void {
    this.isProcessing = true;
    c("Close click");

    this.atividadeService
      .removePlanoExecucao(
        this.atividadeSelecionada.equipamentoId,
        this.atividadeSelecionada.periodicidadeId
      )
      .subscribe((response: boolean) => {
        if (response) {
          this.toastr.success("Plano removido com sucesso");
          this.getById(
            this.equipamentoSelecionadoId,
            this.equipamentoSelecionado
          );
          this.atividadeSelecionada = undefined;
        } else {
          this.toastr.warning("Erro ao tentar remover o plano");
        }
      });
  }

  getProximaDataExecucao(
    originalDataProximaExecucao: Date,
    espacamento: number,
    count: number
  ): Date {
    const indexDefaultPeriodiciade =
      this.defaultPeriodicidades.indexOf(espacamento); // confere se espacamento é uma das peridicidades padrões

    let dataProximaExecucao = moment(
      new Date(originalDataProximaExecucao.getTime())
    ); // cópia da data original

    if (indexDefaultPeriodiciade > 0) {
      const addMeses = this.mesesPeriodicidade[indexDefaultPeriodiciade]; // busca qtde de meses correspondente a periodicidade padrão encontrada

      if (addMeses === 12) {
        dataProximaExecucao.add(count, "year");
      } else {
        dataProximaExecucao.add(addMeses * count, "month"); // .setMonth(dataProximaExecucao.getMonth() + (addMeses * count));
      }

      return dataProximaExecucao.toDate();
    } else {
      // calculo no caso de períodicidades não padrões (!= 30,60,90,180,365)
      return new Date(
        originalDataProximaExecucao.getTime() +
          espacamento * count * 24 * 60 * 60 * 1000
      );
    }
  }

  reimprimirOS(comEvidenciaDeFotos: boolean, osId: number) {
    this.isReprintOS = true;

    this.osservice
      .imprimirOS(osId, 1, comEvidenciaDeFotos ? "S" : "N")
      .subscribe(
        (response) => {
          if (response.success === true) {
            if (response.nenhumResultado === false) {
              window.open(
                `${SCAMP_API_RPT.root}${response.pathRpt}`,
                "_blank",
                "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
              );
            } else {
              this.toastr.warning(response.msgErro);
            }
          } else {
            this.toastr.error(response.msgErro);
          }
          this.isReprintOS = false;
        },
        (err: any) => {
          this.toastr.error(
            "Não foi possível se conectar ao servidor de relatórios",
            "Erro de Conexão"
          );
          this.isReprintOS = false;
        }
      );
  }

  alteraPlanoExecucao(i, atividade) {
    const datasValidas1 = this.validaDatasInicioFinal();
    const datasValidas2 = this.validaInputDateNewDataExecucao(i);

    if (datasValidas1 && datasValidas2) {
      this.atividadeSelecionada = atividade;

      const inputDataInicio = (
        document.getElementById("inputDataInicio") as HTMLInputElement
      ).value;
      const inputDataTermino = (
        document.getElementById("inputDataTermino") as HTMLInputElement
      ).value;

      const inputdn = <HTMLInputElement>(
        document.getElementById("inputDateNewDataExecucao" + i)
      );

      let input_di = new Date(
        new Date(inputDataInicio).getTime() + 3 * 60 * 60 * 1000
      );
      let input_dt = new Date(
        new Date(inputDataTermino).getTime() + 3 * 60 * 60 * 1000
      );
      let input_nd = new Date(
        new Date(inputdn.value).getTime() + 3 * 60 * 60 * 1000
      );

      this.geraNovoPlanoExecucao(input_di, input_dt, input_nd, null);
    }
  }

  validaInputDateNewDataExecucao(i) {
    let valid = true;

    const inputdn = <HTMLInputElement>(
      document.getElementById("inputDateNewDataExecucao" + i)
    );

    inputdn.classList.remove("h-error");

    if (inputdn.parentNode.childNodes.item(2)) {
      inputdn.parentNode.childNodes.item(2).remove();
    }

    const dh = inputdn.value;

    if (!dh) {
      let span = document.createElement("span");
      span.classList.add("txt-danger-fb");
      span.innerHTML = "informe uma data";
      inputdn.classList.add("h-error");
      (<HTMLElement>inputdn.parentNode.parentNode).insertAdjacentElement(
        "afterend",
        span
      );

      valid = false;
    }

    return valid;
  }
}
